const LISTING_ERROR_CODE = {
	LOW_LIMIT: 'too_low_limit',
	LOW_OFFSET: 'too_low_offset',
	HIGH_LIMIT: 'too_high_limit',
	HIGH_OFFSET: 'too_high_offset',
};

export type ApiErrorsResponse = {
	errors: ApiErrorResponse[];
	status_code: number;
	status_message: string;
};

export type ApiErrorResponse = {
	error_code: string;
	error_data?: Record<string, any>;
	error_message: string;
	fields: string[];
};

export const LISTING_ERROR_CODE_TO_NOT_FOUND_CODE = [
	LISTING_ERROR_CODE.LOW_LIMIT,
	LISTING_ERROR_CODE.LOW_OFFSET,
	LISTING_ERROR_CODE.HIGH_LIMIT,
	LISTING_ERROR_CODE.HIGH_OFFSET,
];

export class ApiError extends Error {
	constructor(message: string, options: { cause: Response; url: string; input?: object }) {
		super(message, options);

		this.cause = options.cause;
		this.url = options.url;
		this.input = options.input;
	}

	override cause: Response;

	url: string;

	input?: object;
}
